<div class="lang-switcher" role="group" aria-label="Language">
  <i class="fa fa-globe lang-icon" aria-hidden="true"></i>
  @for (lang of languages; track lang.code; let isLast = $last) {
    <button
      type="button"
      class="lang-btn"
      [class.active]="lang.code === activeLang"
      [attr.aria-pressed]="lang.code === activeLang"
      (click)="switchLang(lang.code)">
      {{ lang.label }}
    </button>
    @if (!isLast) {
      <span class="lang-sep" aria-hidden="true">·</span>
    }
  }
</div>
